function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { nodeArray, Event } from 'meteora';
var MobileMenu = /*#__PURE__*/function () {
  function MobileMenu(menu) {
    var _this = this;
    _classCallCheck(this, MobileMenu);
    this.toggle = null;
    this.menu = menu;
    this.links = {
      main: nodeArray(this.menu.querySelectorAll('[data-mobile-menu-trigger]')),
      direct: nodeArray(this.menu.querySelectorAll('[data-mobile-menu-direct]')),
      children: nodeArray(this.menu.querySelectorAll('[data-mobile-menu-target]'))
    };
    this.links.main.forEach(function (main) {
      var ID = main.getAttribute('data-mobile-menu-trigger');
      main.addEventListener('click', function (e) {
        e.preventDefault();
        _this.findChildren(ID).classList.add('js-resize');
        _this.links.children.forEach(function (child) {
          child.getAttribute('data-mobile-menu-target') === ID ? child.classList.add('js-active') : child.classList.remove('js-active');
        });
        _this.resize();
        _this.hideMainLinks();
      });
    });
    this.links.children.forEach(function (child) {
      child.querySelector('.js-mobile-menu--back').addEventListener('click', function (e) {
        e.preventDefault();
        child.classList.remove('js-resize');
        child.classList.remove('js-active');
        _this.showMainLinks();
        _this.resize();
      });
    });
  }
  _createClass(MobileMenu, [{
    key: "findChildren",
    value: function findChildren(ID) {
      var children = null;
      for (var i = 0; i < this.links.children.length; i++) {
        if (this.links.children[i].getAttribute('data-mobile-menu-target') === ID) {
          children = this.links.children[i];
          break;
        }
      }
      return children;
    }
  }, {
    key: "showMainLinks",
    value: function showMainLinks() {
      this.links.main.forEach(function (link) {
        link.classList.remove('js-hide');
      });
      this.links.direct.forEach(function (link) {
        link.classList.remove('js-hide');
      });
      this.resize();
    }
  }, {
    key: "hideMainLinks",
    value: function hideMainLinks() {
      this.links.main.forEach(function (link) {
        link.classList.add('js-hide');
      });
      this.links.direct.forEach(function (link) {
        link.classList.add('js-hide');
      });
    }
  }, {
    key: "resize",
    value: function resize() {
      // setTimeout(() => {
      // this.menu.Equalizer.update();
      // }, 100);
    }
  }]);
  return MobileMenu;
}();
export { MobileMenu as default };